export default import.meta.ROLLDOWN_FILE_URL_NHJ6QB3ZVMf35ip30RyL0A